<template>

  <div class="dapp-home">

    <DAppGroup :list="ranks" class="dapp-home-section">
      <template slot="title">
        <h2>{{ $t('categoryRanking') }}</h2>
      </template>

      <template slot="item" slot-scope="item">
        <DAppCellList :dapps="item.data.dapps">
          <template slot="title">
            <h4>{{ item.data.category.name }}</h4>
          </template>
        </DAppCellList>
      </template>
    </DAppGroup>

    <DAppCardGroup v-for="collection in collections" class="dapp-home-section"
                   :dapps="collection.list"
                   :key="collection.key">
      <template slot="title">
        <h2>{{ $t('collections.' + collection.key)}}</h2>
      </template>
    </DAppCardGroup>

  </div>

</template>

<script>

  import * as api from '../api'
  import DAppGroup from '../widgets/DAppGroup'
  import DAppCellList from '../widgets/DAppCellList'
  import DAppCardGroup from '../widgets/DAppCardGroup'

  export default {
    name: 'index',
    components: {DAppCardGroup, DAppCellList, DAppGroup},
    data () {
      return {
        banners: [],
        ranks: [],
        collections: []
      }
    },
    mounted () {
      api.getHomeData().then(data => {
        this.banners = data.banners
        this.ranks = data.ranks
        this.collections = data.collections
      })
    }
  }
</script>

<style lang="scss" scoped>

  .dapp-home-section {
    padding-bottom: 20px;
    padding-top: 20px;
  }

  .dapp-home {
    h2 {
      color: #783834;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/index.vue